import { render, staticRenderFns } from "./OverviewData.vue?vue&type=template&id=022f6b8a&"
import script from "./OverviewData.vue?vue&type=script&lang=js&"
export * from "./OverviewData.vue?vue&type=script&lang=js&"
import style0 from "./OverviewData.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports